// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1EventsUpdatePayloadSchema = z.object({
  user_id: z.optional(z.number().int().describe("Change who performed the work")),
  project_id: z.optional(z.number().int().describe("Move to a different project")),
  hours: z.optional(z.number().int().min(0).describe("Update hours worked (0-23)")),
  minutes: z.optional(z.number().int().min(0).max(59).describe("Update minutes worked (0-59)")),
  seconds: z.optional(z.number().int().min(0).max(59).describe("Update seconds worked (0-59)")),
  from: z.coerce.string().describe("Change start time (HH:MM format)").nullish(),
  to: z.coerce.string().describe("Change end time (HH:MM format)").nullish(),
  day: z.optional(z.coerce.string().describe("Move to different date (YYYY-MM-DD)")),
  note: z.coerce.string().describe("Update work description").nullish(),
  sequence: z.optional(z.number().int().describe("Change order within day")),
  estimated_hours: z.optional(z.number().int().min(0).describe("Update planned hours")),
  estimated_minutes: z.optional(z.number().int().min(0).max(59).describe("Update planned minutes")),
  billed: z.optional(z.boolean().describe("Mark as billed/unbilled")),
  locked: z.optional(z.boolean().describe("Lock/unlock entry")),
  billable: z.optional(z.boolean().describe("Change billability")),
  hour_rate: z.optional(z.number().describe("Update hourly billing rate")),
  internal_hour_rate: z.optional(z.number().describe("Update internal cost rate")),
  timer_state: z.optional(z.number().int().describe("Update timer state (0=stopped, 1=running)")),
  suggestion_id: z.number().int().describe("Link to AI suggestion").nullish(),
  external_id: z.coerce.string().describe("Update external reference ID").nullish(),
  forecast_id: z.number().int().describe("Update task that this work fulfills").nullish(),
  forecast_completed_at: z.coerce.string().describe("Update task completion timestamp").nullish(),
  state_id: z.number().int().describe("Change workflow state").nullish(),
  label_ids: z.optional(z.array(z.number().int()).describe("Replace all tags (pass empty array to clear)")),
  user_ids: z.optional(z.array(z.number().int()).describe("Replace team members")),
  entry_ids: z.optional(z.array(z.number().int()).describe("Replace memory entries")),
  timestamps: z.optional(z.array(z.object({
    id: z.optional(z.number().int().describe("Timestamp ID to update (omit to create new)")),
    from: z.coerce.string().describe("Start time (HH:MM)").nullish(),
    to: z.coerce.string().describe("End time (HH:MM)").nullish(),
    entry_ids: z.optional(z.array(z.number().int()).describe("Memory entries for this segment")),
  })).describe("Replace all time segments (pass empty array to clear)")),
  external_links: z.optional(z.array(z.object({
    provider_id: z.coerce.string().describe("Integration provider ID"),
    provider_type: z.coerce.string().describe("External system type (e.g., \"jira\", \"github\")"),
    external_id: z.coerce.string().describe("ID in external system"),
    data: z.optional(z.object({}).describe("Additional metadata")),
    uri: z.optional(z.coerce.string().describe("Direct link to resource")),
  })).describe("Replace all external links (pass empty array to clear)")),
});
